<template>
  <div v-if="showHint" class="table-scroll-hint show-mobile-only">
    <IconArrowLeftRight class="icon icon-big icon-white" />
    <p class="small white center">
      스크롤을 좌우로 움직여<br />
      정보를 확인하세요
    </p>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

import IconArrowLeftRight from '@/components/icons/IconArrowLeftRight.vue';

const showHint = ref(true);

const hideHint = () => {
  showHint.value = false;
};

onMounted(() => {
  // 클릭 / 터치 / 스크롤 중 하나라도 발생하면 제거
  document.addEventListener('click', hideHint, { once: true });
  document.addEventListener('touchstart', hideHint, { once: true });
  document.addEventListener('scroll', hideHint, { once: true, passive: true });
});

onUnmounted(() => {
  document.removeEventListener('click', hideHint);
  document.removeEventListener('touchstart', hideHint);
  document.removeEventListener('scroll', hideHint);
});
</script>

<style scoped lang="scss">
.table-scroll-hint {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;

  min-width: 10rem;
  padding: 1rem;

  background: var(--surface-glass-darkest);
  border-radius: 8px;

  z-index: $z-floating;
  pointer-events: none;
}
</style>
